module.exports = __webpack_public_path__ + "media/svg/cv-46937889.svg";